// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2G_Fi","rootSuccess":"CompleteLink_rootSuccess__1tcjc","rootFailure":"CompleteLink_rootFailure__gVZ4n","isDisabled":"CompleteLink_isDisabled__1-Kzf"};